export default {
  name: 'auth--user',
  apiService: 'auth',
  apiPath: '/users',
};